import React from 'react';
import { Route } from '../Routing/types';
import { GoalSettingsPage } from '@front-activerse/modules';
import descendantRoutes from './descendantRoutes';

const dummy_t = (translationKey: string) => translationKey;

const routes: Route[] = [
  {
    path: '/goal-settings/*',
    element: <GoalSettingsPage descendantRoutes={descendantRoutes} />,
    private: true,
    title: dummy_t('goalSettings.navbarTitle'),
    mobileAppTabIdentifier: '',
    descendantRoutes,
  },
];

export default routes;
